import React, { useEffect, useRef, useState } from "react";
import logoIcon from "../../assets/logo-icon.png";
import "./PoweredByCliniKit.css";

/**
 * Small branded line shown on patient-facing public pages
 * (confirm / sign / questionnaire / book). Links back to the
 * marketing site with UTM attribution.
 *
 * The bar is position:fixed, so it reserves its own height on <body>
 * (padding-bottom via --ck-powered-by-height) — guaranteeing it can never
 * cover page content such as submit / sign buttons on any public page.
 */
const PoweredByCliniKit = ({ source = "patient_page" }) => {
  const barRef = useRef(null);
  const [barHeight, setBarHeight] = useState(72);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return undefined;
    const root = document.documentElement;
    const body = document.body;

    const apply = () => {
      const h = Math.ceil(bar.getBoundingClientRect().height);
      if (h > 0) setBarHeight(h);
      root.style.setProperty("--ck-powered-by-height", `${h}px`);
    };

    body.classList.add("has-powered-by");
    apply();

    let observer = null;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(apply);
      observer.observe(bar);
    }
    window.addEventListener("resize", apply);
    window.addEventListener("orientationchange", apply);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", apply);
      window.removeEventListener("orientationchange", apply);
      body.classList.remove("has-powered-by");
      root.style.removeProperty("--ck-powered-by-height");
    };
  }, []);

  return (
    <>
      {/* In-flow spacer: sits after the page content inside #root, so the
          fixed bar below can never cover the page's last element. */}
      <div className="powered-by-clinikit-spacer" style={{ height: barHeight + 8 }} aria-hidden="true" />
    <div className="powered-by-clinikit" ref={barRef}>
      <a
        href={`https://clinikit.co.il/?utm_source=${source}&utm_medium=powered_by&utm_campaign=patient_pages`}
        target="_blank"
        rel="noopener noreferrer"
        className="powered-by-clinikit-link"
      >
        <div className="powered-by-clinikit-brand-group">
          <img src={logoIcon} alt="" className="powered-by-clinikit-icon" />
          <span className="powered-by-clinikit-brand">CliniKit</span>
        </div>
        <div className="powered-by-clinikit-dot">·</div>
        <div className="powered-by-clinikit-text">תוכנה לניהול קליניקה</div>
      </a>
    </div>
    </>
  );
};

export default PoweredByCliniKit;
